<template>
  <div class="car">
    <b-row class="no-gutters">
      <b-col>
        <Slider
          :id="id"
          :images="allPictures"
          :sliderId="id | prefixSliderId"
          :size="sliderSize"
          :link="code | carLink(auction)"
        />
      </b-col>
    </b-row>
    <b-row class="no-gutters">
      <b-col class="title">
        <router-link :to="code | carLink(auction)">{{ brand }} {{ carMake }}</router-link>
      </b-col>
      <b-col cols="1" class="status">
        <Status :status="currentBidStatus" />
      </b-col>
    </b-row>
    <b-row class="no-gutters">
      <b-col v-if="model > 0" class="modelo">Modelo {{ model }}</b-col>
    </b-row>
    <b-row class="no-gutters">
      <b-col>
        <Bid :bid="bid" :id="id" :bidAffiliate="bidAffiliate" :code="code" :bidStatus="bidStatus" />
      </b-col>
    </b-row>
    <b-row class="no-gutters">
      <b-col v-if="base > 0" class="base">Base {{ base | currency }}</b-col>
    </b-row>
  </div>
</template>

<script>
import Bid from "../item/Bid";
import Status from "../item/Status";
import Slider from "../utils/Slider";
import utils from "../../assets/js/utils";

export default {
  name: "Car",
  components: {
    Bid,
    Status,
    Slider
  },
  props: {
    id: {
      type: String,
      default: "0"
    },
    code: {
      type: String,
      default: "0"
    },
    brand: {
      type: String,
      default: ""
    },
    make: {
      type: String,
      default: ""
    },
    model: {
      type: Number,
      default: 0
    },
    base: {
      type: Number,
      default: 0
    },
    pictures_slider: {
      type: Array,
      default: function() {
        return [];
      }
    },
    pictures_main: {
      type: Array,
      default: function() {
        return [];
      }
    },
    pictures_normal: {
      type: Array,
      default: function() {
        return [];
      }
    },
    auction: {
      type: Number,
      default: 0
    },
    bid: {
      type: Number,
      default: 0
    },
    bidAffiliate: {
      type: Number,
      default: 0
    },
    bidStatus: {
      type: String,
      default: "on"
    },
    soldCode: {
      type: Number,
      default: 0
    },
    soldPending: {
      type: Boolean,
      default: false
    }
  },
  created: function() {
    // Component initialization
  },
  updated: function() {
    this.dataBidStatus = this.bidStatus;
  },
  watch: {
    // Watch for WebSocket messages from the store
    '$store.getters.socketMessage': {
      handler: function(message) {
        if (!message || !message.message || !message.message.action) {
          return;
        }
        switch (message.message.action) {
          case "auctionStarts":
            if (message.message.carId !== this.id) {
              return;
            }
            this.dataBidStatus = "almost";
            break;

          case "auctionEnds":
            if (message.message.carId !== this.id) {
              return;
            }
            this.dataBidStatus = "off";
        }
      },
      deep: true
    }
  },
  data() {
    return {
      dataBidStatus: "",
      sliderSize: "small"
    };
  },
  filters: {
    currency: function(amount) {
      return utils.formatCurrency(amount);
    },
    carLink: function(code, auction) {
      return "/partida/" + auction + "/" + code;
    },
    prefixSliderId: function(id) {
      return "car_slider_" + id;
    }
  },
  computed: {
    allPictures: function() {
      return []
        .concat(this.pictures_main !== null ? this.pictures_main : [])
        .concat(this.pictures_normal !== null ? this.pictures_normal : []);
    },
    carMake: function() {
      let make = this.make;
      if (make.substring(0, this.brand.length) === this.brand) {
        make = make.substring(this.brand.length);
      }
      if (make === "SIN LINEA") {
        make = "";
      }
      return make;
    },
    currentBidStatus: function() {
      return this.dataBidStatus !== "" ? this.dataBidStatus : this.bidStatus;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.car {
  font-weight: $font-weight-bold;
  margin-bottom: 5px;
}

.title,
.status {
  font-size: 1.5rem;

  @media (max-width: prev-viewport-max-size("xl")) {
    font-size: 1.3rem;
  }

  @media (max-width: prev-viewport-max-size("lg")) {
    font-size: 1rem;
  }
}

.title {
  min-height: 3rem;
  position: relative;

  &::before {
    position: absolute;
    content: "";
    bottom: 0;
    left: 0;
    width: 33%;
    height: 1px;
    background-color: $red;
  }

  a {
    color: $black;
  }
}

.modelo {
  color: $gray-500;
  font-size: 1.2rem;

  @media (max-width: prev-viewport-max-size("xl")) {
    font-size: 1.1rem;
  }

  @media (max-width: prev-viewport-max-size("lg")) {
    font-size: 1rem;
  }
}

.base {
  @media (max-width: prev-viewport-max-size("lg")) {
    font-size: 0.8rem;
  }
}
</style>
